import React from 'react';
import { IconContext } from "react-icons";
import { GoComment } from "react-icons/go";

import { Trans } from 'react-i18next';

const ObservationsCard = ( props ) => {

  return (
    <div className="card observations" onClick={ ( ) => { document.getElementById( 'observationsSection' ).scrollIntoView({ behavior: 'smooth' }) } }>
      <div className="data">
        <div className="amount"> { props.amount } </div>
        <div className="tag"> <Trans>Observations</Trans> </div>
      </div>
      <div className="icon">
        <div className="container">
          <IconContext.Provider value={{ size: "20px" }}>
            <div>
              <GoComment />
            </div>
          </IconContext.Provider>
        </div>
      </div>
    </div>
  )
}

export default ObservationsCard
